<template>
  <div class="billing-application">
    <div v-if="customerId && pricingDetails.length > 0">
      <div class="max-width">
        <h1 class="pl-1 pt-1 pr-1">
          Billing details
        </h1>
      </div>

      <div class="ml-2 mt-2 mr-2">
        <subscription-details></subscription-details>
      </div>
      <hr class="ml-2 mr-2 mb-3" />
      <div class="ml-2 mt-2 mr-2">
        <UsageLimitDetails></UsageLimitDetails>
      </div>
      <hr class="ml-2 mr-2 mb-3" />
      <div class="ml-2 mt-2 mr-2">
        <UsersDetails></UsersDetails>
      </div>
    </div>
    <SkeletonLoader v-else class="" :skeleton-parameters="skeletonParameters"></SkeletonLoader>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import Ripple from 'vue-ripple-directive'
import SkeletonLoader from '@/components/SkeletonLoader'
import SubscriptionDetails from './components/SubscriptionDetails.vue'
import UsageLimitDetails from './components/UsageLimitDetails.vue'
import UsersDetails from './components/UsersDetails.vue'

export default {
  components: { SubscriptionDetails, UsageLimitDetails, UsersDetails, SkeletonLoader },
  directives: {
    Ripple
  },
  data: function() {
    return {
      skeletonParameters: { type: 'vertical', count: 1 }
    }
  },
  setup() {},
  computed: {
    ...mapState('billing', ['customerId', 'pricingDetails'])
  },
  watch: {},
  async mounted() {
    this.$store.dispatch('billing/getPricingDetails', {
      self: this
    })
    this.$store.dispatch('billing/getBillingDetails', {
      self: this
    })
  }
}
</script>

<style lang="scss" scoped>
@import '@/assets/scss/variables/_variables';
.billing-application {
  height: calc(100vh - 10em);
  background: #fff;
  overflow-y: scroll;

  @media screen and (max-width: 1000px) {
    height: calc(100vh - 11em);
  }
}
.dark-layout {
  .billing-application {
    background-color: $theme-dark-card-bg;
  }
}

.max-width {
  width: 100%;
}
</style>
